export const isValidEmail = (email) => {
    if (!email) return false; // empty string
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };
  